import TableCell from '@mui/material/TableCell';
import React, { memo } from 'react';
import { defaultHeaderNotDoctor, sizeColumn } from 'src/components/calendar/styles';

const DaysCalendarHeaderSecond = (props: any) => {
  const getStyleDoctor = (doctorid: number) => {
    return {
      bgColor:
        props.doctorsData && props.doctorsData[doctorid] && props.doctorsData[doctorid]['bgcolor']
          ? props.doctorsData[doctorid]['bgcolor']
          : '',
      color:
        props.doctorsData &&
        props.doctorsData[doctorid] &&
        props.doctorsData[doctorid]['fontcolor']
          ? props.doctorsData[doctorid]['fontcolor']
          : '',
    };
  };

  return props.daysCal.map((day: any, indexDay: number) => (
    day['doctors'] &&
        day['doctors'].map((doctor: any, indexDoctor: number) => (
          <TableCell
            key={day['day'] + '-doctor' + doctor['id']}
            align='center'
            sx={{
              ...defaultHeaderNotDoctor,
              ...sizeColumn,
              bgcolor: getStyleDoctor(doctor['id']).bgColor,
              color: getStyleDoctor(doctor['id']).color,
              // borderRight: day['lastcolumn'] === 'doctor' && indexDoctor === day['doctors'].length - 1 ?
              //   getBorderStyle(day) || getBorderStyleNextDay(indexDay) : ''
            }}
          >
            {doctor['name']}
          </TableCell>
        ))
  ));
};

export default memo(DaysCalendarHeaderSecond);
